import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import ImageControl from "../common/ImageControl";
import Text from "../common/Text";

import { saveJobStat } from "../../states/actions/fetchDashboard";
import { useSelector, useDispatch } from "react-redux";

import { jobProgressColor } from "../../helpers/helpers";
import { makeSalaryString, doFirstUpperRestLower } from "../../helpers/helpers";
import * as paths from "../../constants/paths";
// import { FaChevronDown } from "react-icons/fa";
const JobBlk = ({
  data,
  admin,
  job,
  saveJob,
  isJobSaving,
  handleJobApplyPopup,
  handleShowSigninPopup,
  showSigninPopup,
  openTooltipJobId,
  setOpenTooltipJobId,
  is_global_val = null,
}) => {
  const authToken = useSelector((state) => state.fetchSignin.authToken);
  const dispatch = useDispatch();
  const isStatUpdating = useSelector(
    (state) => state.fetchDashboard.isStatUpdating
  );
  const [open, setOpen] = useState(null);
  const ref = useRef();

  useEffect(() => {
    const close = (e) => !ref.current.contains(e.target) && setOpen(null);
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);
  const isTooltipOpen = openTooltipJobId === job.id;

  const toggle = (type) => setOpen(open === type ? null : type);
  const tooltipRef = useRef(null);
  const handleCompanyClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenTooltipJobId(isTooltipOpen ? null : job.id);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target) &&
        !event.target.closest(".company-link") // allow clicking the <a>
      ) {
        setOpenTooltipJobId(null);
      }
    };

    if (isTooltipOpen) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isTooltipOpen]);
  // const handleClick = (e) => {
  //   e.preventDefault();
  //   setShowTooltip((prev) => !prev);
  // };
  const tooltip =
    "A job is labelled as ‘definitely sponsor' if the job description clearly states that the role is eligible for visa sponsorship or if the company has a policy of sponsoring visas for all its roles.";
  const handleSaveJob = (id) => {
    saveJob({ id: id });
  };

  const handleJobStatUpdate = (formData) => {
    dispatch(saveJobStat(formData));
  };
  return (
    <>
      {job && (
        <div className={admin ? "job_blk edit" : "job_blk"}>
          <div className="top">
            <div className="ico fill">
              {job.image == "" || job.image == null ? (
                <img
                  src={paths.SITE_BASE_URL + "/images/no-image.svg"}
                  alt="no image found"
                />
              ) : (
                <ImageControl
                  src={job.image}
                  folder="companies"
                  isThumb={true}
                />
              )}
            </div>
            <div className="title">
              <h4
                className="mb-0 job_title"
                onClick={() => handleJobApplyPopup(job)}
                style={{ cursor: "pointer" }}
              >
                {job.title}
              </h4>
              {/* {console.log("is_global_val", is_global_val)} */}
              {parseInt(is_global_val) !== 1 && (
                <>
                  <div className="company">
                    {/* {job.company_link == null || job.company_link == "" ? (
                  <a href="javascript:void(0);">
                    <Text string={job.company_name} />
                  </a>
                ) : (
                  <a href={job.company_link} target="_blank">
                    <Text string={job.company_name} />
                  </a>
                )} */}
                    <div className="company company_1 tooltip-wrapper">
                      <a href="javascript:void(0)" onClick={handleCompanyClick}>
                        {job.company_name}
                        <div className="info_icon">
                          <img
                            src={paths.SITE_BASE_URL + "/images/info.png"}
                            alt=""
                          />
                        </div>
                      </a>

                      {isTooltipOpen && parseInt(is_global_val) !== 1 && (
                        <div className="globals" ref={tooltipRef}>
                          <p className="globals_info">
                            Based on Home Office data , {job.company_name}{" "}
                            sponsored {job.computed_cos_total ?? 0} people in
                            2025.{" "}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
              <div ref={ref} className="tooltip-wrapper-flex">
                {job.is_promoted === "1" && (
                  <div className="tooltip-wrapper">
                    <span
                      className="featured_job_new two"
                      // onClick={(e) => (e.preventDefault(), toggle("promoted"))}
                    >
                      {/* Promoted */}
                      {data.is_promoted_label}
                    </span>

                    {/* {open === "promoted" && (
                      <div className="globals">
                        <p className="globals_info">{data.is_promoted_desc}</p>
                      </div>
                    )} */}
                  </div>
                )}

                {job.likely_to_sponsor === "yes" && (
                  <div className={`tooltip-wrapper ${open && "open"}`}>
                    <Link
                      to=""
                      className="featured_job_new3"
                      onClick={(e) => (e.preventDefault(), toggle("likely"))}
                    >
                      {data.likely_sponsor_label}
                      {/* <FaChevronDown
                        size={13}
                        className={`chevron ${open === "likely" ? "open" : ""}`}
                      /> */}
                    </Link>
                    {open === "likely" && (
                      <div className="globals">
                        <p className="globals_info">
                          {data.likely_sponsor_desc}
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {job.definitely_sponsored === "yes" && (
                  <div className={`tooltip-wrapper ${open && "open"}`}>
                    <Link
                      to=""
                      className="featured_job_new2"
                      onClick={(e) => (
                        e.preventDefault(), toggle("definitely")
                      )}
                    >
                      {data.definitely_sponsor_label}
                      {/* <FaChevronDown
                        size={13}
                        className={`chevron ${
                          open === "definitely" ? "open" : ""
                        }`}
                      /> */}
                    </Link>
                    {open === "definitely" && (
                      <div className="globals">
                        <p className="globals_info">
                          {data.definitely_sponsor_desc}
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {job.new_entrant === "yes" && (
                  <div className={`tooltip-wrapper ${open && "open"}`}>
                    <Link
                      to=""
                      className="featured_job_new4"
                      onClick={(e) => (e.preventDefault(), toggle("new"))}
                    >
                      {data.new_entry_label}
                      {/* <FaChevronDown
                        size={13}
                        className={`chevron ${open === "new" ? "open" : ""}`}
                      /> */}
                    </Link>
                    {open === "new" && (
                      <div className="globals">
                        <p className="globals_info">{data.new_entry_desc}</p>
                      </div>
                    )}
                  </div>
                )}

                {job.student_graduate === "yes" && (
                  <div className={`tooltip-wrapper ${open && "open"}`}>
                    <Link
                      to=""
                      className="featured_job_new5"
                      onClick={(e) => (e.preventDefault(), toggle("student"))}
                    >
                      {data.student_label}
                      {/* <FaChevronDown
                        size={13}
                        className={`chevron ${
                          open === "student" ? "open" : ""
                        }`}
                      /> */}
                    </Link>
                    {open === "student" && (
                      <div className="globals">
                        <p className="globals_info">{data.student_desc}</p>
                      </div>
                    )}
                  </div>
                )}

                {/* {job.student_graduate == "yes" && (
                  <div className="tooltip-wrapper">
                    <Link
                      to=""
                      className="featured_job_new4"
                      onClick={(e) => (e.preventDefault(), toggle("student"))}
                    >
                      {data.student_label}
                    </Link>
                    {open === "student" && (
                      <div className="globals">
                        <p className="globals_info">{data.student_desc}</p>
                      </div>
                    )}
                  </div>
                )} */}
              </div>
              {admin ? (
                ""
              ) : (
                <ul className="mini_lst">
                  <li>
                    <img
                      src={process.env.PUBLIC_URL + "/images/new/location.svg"}
                      alt=""
                    />
                    <Text string={job.city} />
                  </li>
                  <li>
                    <img
                      src={process.env.PUBLIC_URL + "/images/new/teacher.svg"}
                      alt=""
                    />
                    <Text
                      string={`${
                        job.degree_requirement == "no-minimum"
                          ? "No Mminimum"
                          : job.degree_requirement
                      }`}
                    />
                  </li>
                  <li>
                    <img
                      className="sm_icon_pound"
                      src={process.env.PUBLIC_URL + "/images/pound1.png"}
                      alt=""
                    />
                    {makeSalaryString(
                      job.min_salary,
                      job.max_salary,
                      doFirstUpperRestLower(job.salary_interval)
                    )}
                  </li>
                </ul>
              )}
            </div>
            {admin ? (
              <div className="act_btn">
                <Link to="/dashboard">
                  <img
                    src={process.env.PUBLIC_URL + "/images/icon-edit.svg"}
                    alt=""
                  />
                </Link>
              </div>
            ) : (
              <div className="act_btn">
                {job.saved ? (
                  <div type="button" className="book_mark_active">
                    <img
                      src={process.env.PUBLIC_URL + "/images/icon-bookmark.svg"}
                      alt=""
                    />
                  </div>
                ) : (
                  <a
                    type="button"
                    onClick={
                      authToken
                        ? () => handleSaveJob(job.id)
                        : handleShowSigninPopup
                    }
                    disabled={isJobSaving}
                  >
                    <img
                      src={process.env.PUBLIC_URL + "/images/icon-bookmark.svg"}
                      alt=""
                    />
                  </a>
                )}
              </div>
            )}
          </div>
          {admin ? (
            <div className="btm">
              <div className="form_row row">
                <div className="col-xl col-lg-4 col-md-6">
                  <h5>Online Test</h5>
                  <div className="form_blk">
                    <select
                      disabled={isStatUpdating}
                      defaultValue={job.online_test}
                      name="online_test"
                      className={`input ${jobProgressColor(job.online_test)}`}
                      onChange={(e) =>
                        handleJobStatUpdate({
                          saved_id: job.saved_id,
                          field: "online_test",
                          value: e.target.value,
                        })
                      }
                    >
                      <option value="">Select</option>
                      <option value="not_invited">Not Invited</option>
                      <option value="waiting_on_hold">Waiting/On Hold</option>
                      <option value="completed">Completed</option>
                      <option value="passed">Passed</option>
                      <option value="not_applicable">Not Applicable</option>
                      <option value="failed">Failed</option>
                      <option value="withdrawn">Withdrawn</option>
                    </select>
                  </div>
                </div>
                <div className="col-xl col-lg-4 col-md-6">
                  <h5>Interview</h5>
                  <div className="form_blk">
                    <select
                      disabled={isStatUpdating}
                      defaultValue={job.interview}
                      name="interview"
                      id=""
                      className={`input ${jobProgressColor(job.interview)}`}
                      onChange={(e) =>
                        handleJobStatUpdate({
                          saved_id: job.saved_id,
                          field: "interview",
                          value: e.target.value,
                        })
                      }
                    >
                      <option value="">Select</option>
                      <option value="waiting_on_hold">Waiting/On Hold</option>
                      <option value="completed">Completed</option>
                      <option value="passed">Passed</option>
                      <option value="not_applicable">Not Applicable</option>
                      <option value="failed">Failed</option>
                      <option value="withdrawn">Withdrawn</option>
                    </select>
                  </div>
                </div>
                <div className="col-xl col-lg-4 col-md-6">
                  <h5>Assessment Centre</h5>
                  <div className="form_blk">
                    <select
                      disabled={isStatUpdating}
                      defaultValue={job.second_round_interview}
                      name="second_round_interview"
                      id=""
                      className={`input ${jobProgressColor(
                        job.second_round_interview
                      )}`}
                      onChange={(e) =>
                        handleJobStatUpdate({
                          saved_id: job.saved_id,
                          field: "second_round_interview",
                          value: e.target.value,
                        })
                      }
                    >
                      <option value="">Select</option>
                      <option value="waiting_on_hold">Waiting/On Hold</option>
                      <option value="completed">Completed</option>
                      <option value="passed">Passed</option>
                      <option value="not_applicable">Not Applicable</option>
                      <option value="failed">Failed</option>
                      <option value="withdrawn">Withdrawn</option>
                    </select>
                  </div>
                </div>
                <div className="col-xl col-lg-4 col-md-6">
                  <h5>final round interview</h5>
                  <div className="form_blk">
                    <select
                      disabled={isStatUpdating}
                      defaultValue={job.final_round_interview}
                      name="final_round_interview"
                      id=""
                      className={`input ${jobProgressColor(
                        job.final_round_interview
                      )}`}
                      onChange={(e) =>
                        handleJobStatUpdate({
                          saved_id: job.saved_id,
                          field: "final_round_interview",
                          value: e.target.value,
                        })
                      }
                    >
                      <option value="">Select</option>
                      <option value="waiting_on_hold">Waiting/On Hold</option>
                      <option value="completed">Completed</option>
                      <option value="passed">Passed</option>
                      <option value="not_applicable">Not Applicable</option>
                      <option value="failed">Failed</option>
                      <option value="withdrawn">Withdrawn</option>
                    </select>
                  </div>
                </div>
                <div className="col-xl col-lg-4 col-md-6">
                  <h5>offer</h5>
                  <div className="form_blk">
                    <select
                      disabled={isStatUpdating}
                      defaultValue={job.offer}
                      name="offer"
                      id=""
                      className={`input ${jobProgressColor(job.offer)}`}
                      onChange={(e) =>
                        handleJobStatUpdate({
                          saved_id: job.saved_id,
                          field: "offer",
                          value: e.target.value,
                        })
                      }
                    >
                      <option value="">Select</option>
                      <option value="waiting_on_hold">Waiting/On Hold</option>
                      <option value="received">Received</option>
                      <option value="accepted">Accepted</option>
                      <option value="withdrawn">Withdrawn</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      )}
    </>
  );
};

export default JobBlk;
